import {ref} from 'vue';
import {defineStore} from 'pinia';

type MessageType = 'success' | 'error' | 'info' | 'warning';
export type Message = {
    id: string;
    type: MessageType;
    msg: string;
    use_html?: boolean;
};
export type AddMessageInput = Omit<Message, 'id'> & {duration?: number};

export const useMessageStore = defineStore('message', () => {
    const messages = ref<Message[]>([]);

    const addMessage = (data: AddMessageInput) => {
        const ID = `lmsg_${Date.now()}_${Math.floor(Math.random() * 10000)}`;

        messages.value.push({
            id: ID,
            type: data.type,
            msg: data.msg,
            use_html: data.use_html || false,
        });

        if (!data.duration || data.duration !== -1) {
            const duration = data.duration || 3500;
            setTimeout(() => {
                removeMessage(ID);
            }, duration);
        }
    };

    const removeMessage = (id: string) => {
        messages.value = messages.value.filter((message) => message.id !== id);
    };

    return {
        messages,
        addMessage,
        removeMessage,
    };
});

export const displayMessage = (data: AddMessageInput) => {
    const messageStore = useMessageStore();
    messageStore.addMessage(data);
};
